// extracted by mini-css-extract-plugin
export default {"button1":"Logout_button1__c2Z2i"};